import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../i18n";
import ScrollReveal from "./ScrollReveal";

function PrivacyPolicy() {
  const { language } = useLanguage();
  const t = translations[language].privacyPolicy;
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Scroll al inicio de la página cuando se monta el componente
    window.scrollTo({ top: 0, behavior: "smooth" });
    
    // Esperar a que termine el scroll antes de activar las animaciones
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsReady(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };

    // Timeout de seguridad por si el scroll termina muy rápido
    const timeoutId = setTimeout(() => {
      setIsReady(true);
      window.removeEventListener("scroll", handleScroll);
    }, 800); // 800ms debería ser suficiente para el scroll suave

    // Escuchar el evento de scroll
    window.addEventListener("scroll", handleScroll);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Si aún no está listo, mostrar contenido oculto
  if (!isReady) {
    return (
      <div className="privacy-policy-container" style={{ opacity: 0 }}>
        <div className="section-title">
          {">  " + t.title}
        </div>
      </div>
    );
  }

  return (
    <div className="privacy-policy-container">
      <ScrollReveal delay={0.2}>
        <div className="section-title">
          {">  " + t.title}
        </div>
        <p className="privacy-policy-last-updated">
          {t.lastUpdated}
        </p>
      </ScrollReveal>

      <ScrollReveal delay={0.3}>
        <div className="privacy-policy-intro">
          <p>
            {t.introduction}
          </p>
        </div>
      </ScrollReveal>

      <ScrollReveal delay={0.4}>
        <section className="privacy-policy-section">
          <h2>
            {t.responsible.title}
          </h2>
          <p>
            {t.responsible.content}
          </p>
          <p>
            <strong>{t.responsible.name}</strong>
          </p>
          <a href="mailto:izamm1610@gmail.com">
            {t.responsible.email}
          </a>
        </section>
      </ScrollReveal>

      <ScrollReveal delay={0.5}>
        <section className="privacy-policy-section">
          <h2>
            {t.dataCollected.title}
          </h2>
          <p>
            {t.dataCollected.content}
          </p>
          <ul className="privacy-policy-list">
            {t.dataCollected.items.map((item, index) => (
              <li key={index}>
                <span>•</span> {item}
              </li>
            ))}
          </ul>
        </section>
      </ScrollReveal>

      <ScrollReveal delay={0.6}>
        <section className="privacy-policy-section">
          <h2>
            {t.purpose.title}
          </h2>
          <p>
            {t.purpose.content}
          </p>
          <ul className="privacy-policy-list">
            {t.purpose.items.map((item, index) => (
              <li key={index}>
                <span>•</span> {item}
              </li>
            ))}
          </ul>
        </section>
      </ScrollReveal>

      <ScrollReveal delay={0.7}>
        <section className="privacy-policy-section">
          <h2>
            {t.legalBasis.title}
          </h2>
          <p>
            {t.legalBasis.content}
          </p>
        </section>
      </ScrollReveal>

      <ScrollReveal delay={0.8}>
        <section className="privacy-policy-section">
          <h2>
            {t.dataSharing.title}
          </h2>
          <p>
            {t.dataSharing.content}
          </p>
          <p>
            {t.dataSharing.content2}
          </p>
        </section>
      </ScrollReveal>

      <ScrollReveal delay={0.9}>
        <section className="privacy-policy-section">
          <h2>
            {t.dataRetention.title}
          </h2>
          <p>
            {t.dataRetention.content}
          </p>
        </section>
      </ScrollReveal>

      <ScrollReveal delay={1.0}>
        <section className="privacy-policy-section">
          <h2>
            {t.userRights.title}
          </h2>
          <p>
            {t.userRights.content}
          </p>
          <ul className="privacy-policy-list">
            {t.userRights.items.map((item, index) => (
              <li key={index}>
                <span>•</span> {item}
              </li>
            ))}
          </ul>
          <p>
            {t.userRights.contact}
          </p>
        </section>
      </ScrollReveal>

      <ScrollReveal delay={1.1}>
        <section className="privacy-policy-section">
          <h2>
            {t.cookies.title}
          </h2>
          <p>
            {t.cookies.content}
          </p>
        </section>
      </ScrollReveal>

      <ScrollReveal delay={1.2}>
        <section className="privacy-policy-section">
          <h2>
            {t.security.title}
          </h2>
          <p>
            {t.security.content}
          </p>
        </section>
      </ScrollReveal>

      <ScrollReveal delay={1.3}>
        <section className="privacy-policy-section">
          <h2>
            {t.changes.title}
          </h2>
          <p>
            {t.changes.content}
          </p>
        </section>
      </ScrollReveal>

      <ScrollReveal delay={1.4}>
        <div className="privacy-policy-back-link">
          <Link to="/">
            {t.backToHome}
          </Link>
        </div>
      </ScrollReveal>
    </div>
  );
}

export default PrivacyPolicy;
